var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBanner404(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 514,
    height: 300,
    viewBox: "0 0 514 300",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M317.5 0C319.709 0 321.5 1.79086 321.5 4V38.8571C321.5 41.0663 319.709 42.8571 317.5 42.8571H239.833C237.624 42.8571 235.833 44.648 235.833 46.8571V253.143C235.833 255.352 237.624 257.143 239.833 257.143H274.667C276.876 257.143 278.667 255.352 278.667 253.143V89.7143C278.667 87.5051 280.458 85.7143 282.667 85.7143H317.5C319.709 85.7143 321.5 87.5051 321.5 89.7143V296C321.5 298.209 319.709 300 317.5 300H197C194.791 300 193 298.209 193 296V4C193 1.79086 194.791 0 197 0L317.5 0Z",
    fill: "url(#paint0_linear_7130_6126)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M475.167 0C472.958 0 471.167 1.79086 471.167 4V296C471.167 298.209 472.958 300 475.167 300H510C512.209 300 514 298.209 514 296V4C514 1.79086 512.209 0 510 0H475.167ZM368.083 0C365.874 0 364.083 1.79086 364.083 4V167.429C364.083 169.638 365.874 171.429 368.083 171.429H432.333C434.542 171.429 436.333 169.638 436.333 167.429V132.571C436.333 130.362 434.542 128.571 432.333 128.571H410.917C408.708 128.571 406.917 126.781 406.917 124.571V4C406.917 1.79086 405.126 0 402.917 0H368.083ZM111.083 0C108.874 0 107.083 1.79086 107.083 4V296C107.083 298.209 108.874 300 111.083 300H145.917C148.126 300 149.917 298.209 149.917 296V4C149.917 1.79086 148.126 0 145.917 0H111.083ZM3.99999 0C1.79086 0 0 1.79086 0 4V167.429C0 169.638 1.79086 171.429 4 171.429H68.25C70.4591 171.429 72.25 169.638 72.25 167.429V132.571C72.25 130.362 70.4591 128.571 68.25 128.571H46.8333C44.6242 128.571 42.8333 126.781 42.8333 124.571V4C42.8333 1.79086 41.0425 0 38.8333 0H3.99999Z",
    fill: "url(#paint1_linear_7130_6126)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7130_6126",
    x1: 257.25,
    y1: 0,
    x2: 257.25,
    y2: 300,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#88306D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9999,
    stopColor: "#E9478F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9478F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_7130_6126",
    x1: 257,
    y1: 0,
    x2: 257,
    y2: 300,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#88306D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9999,
    stopColor: "#E9478F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9478F"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBanner404);
export default __webpack_public_path__ + "static/media/banner-404.6707906ac6c1448c08d2bfd92f6d62e2.svg";
export { ForwardRef as ReactComponent };